import React from 'react'

interface LogoProps {
  className?: string
  isDark?: boolean
}

export const Logo: React.FC<LogoProps> = ({ className, isDark = true }) => {
  const logoSrc = isDark ? '/img/graviton-dark.svg' : '/img/gravtion.svg'

  return <img src={logoSrc} alt='Graviton logo' className={className} />
}
